import React, { useEffect, useState, useRef } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import axios from "axios";
import DataTable from "react-data-table-component";
import { env } from "./const";
import { headers } from "../utils/common";
import { getRole } from "../utils/common";
import { Role } from "../utils/role";
import DeactivateFarm from "./DeactivateFarm";
import { Modal, Button } from "react-bootstrap";
import { getUserName } from "../utils/common";
import EchartBar from "../dashboard/barchart";
import { useLoading, Bars } from "@agney/react-loading";
import * as axiosInstance from "../utils/axiosinstace";
import $ from "jquery";
import "select2";
import { Tabs, Tab } from "react-bootstrap-tabs";
import { ConfigProvider, Table } from "antd";
import NaturalVsCullingChart from "./NaturalVsCullingChart";
import { useTranslation } from 'react-i18next';
<ConfigProvider
  theme={{
    token: {
      colorPrimary: "#1890ff",
      fontSize: 12,
    },
  }}
></ConfigProvider>;

const BatchMortlaity = () => {
  const { t } = useTranslation(['analytics', 'common']);
  // Tab labels double as the value compared in onSelect below — one source only,
  // otherwise translating the label silently stops the phase-wise fetch firing.
  const TAB_DAY_WISE = t('analytics:mortality.dayWise');
  const TAB_PHASE_WISE = t('analytics:mortality.phaseWise');
  const { containerProps, indicatorEl } = useLoading({
    loading: true,
    indicator: <Bars width="30" color="#333" />,
  });
  const [role] = useState(getRole());
  const [farmData, setFarmData] = useState([]);
  const [batchData, setBatchData] = useState([]);
  const [headersobj] = useState(headers());
  const [batchID, setBatchID] = useState("");
  const [numbers, setNumbers] = useState([]);
  const [showNumbers, setShowNumbers] = useState(false);
  const [graphData, setGraphData] = useState({});
  const [showGraph, setShowGraph] = useState(false);
  const [showLoader, setShowloader] = useState(false);
  const [mortalityData, setMortalityData] = useState([]);
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
    trigger,
  } = useForm({
    mode: "onChange",
  });

  const columns = [
    {
      title: t('common:time.day'),
      dataIndex: "day",
      key: "day",
      width: 70,
      align: "center",
      sorter: (a, b) => a.day - b.day,
      defaultSortOrder: "ascend",
    },
    {
      title: t('common:fields.date'),
      dataIndex: "Date",
      key: "Date",
      width: 120,
      align: "center",
    },
    {
      title: t('common:time.phase'),
      dataIndex: "Phase",
      key: "Phase",
      width: 70,
      align: "center",
    },
    {
      title: t('common:metrics.mortality'),
      children: [
        {
          title: t('common:metrics.natural'),
          dataIndex: "Natural",
          key: "Natural",
          width: 100,
          align: "center",
        },
        {
          title: t('common:metrics.culling'),
          dataIndex: "Culling",
          key: "Culling",
          width: 100,
          align: "center",
        },
      ],
    },

    {
      title: t('analytics:mortality.aggregate'),
      children: [
        {
          title: t('common:metrics.natural'),
          dataIndex: "Aggregate_Natural",
          key: "Aggregate_Natural",
          width: 120,
          align: "center",
        },
        {
          title: t('common:metrics.culling'),
          dataIndex: "Aggregate_Culling",
          key: "Aggregate_Culling",
          width: 120,
          align: "center",
        },
      ],
    },
  ];
  const phasecolumns = [
    {
      title: t('common:time.phase'),
      dataIndex: "Phase",
      key: "phase",
      align: "left",
    },
    {
      title: t('analytics:mortality.timePeriod'),
      dataIndex: "Block",
      key: "block",
      align: "left",
    },
    {
      title: t('common:fields.startDate'),
      dataIndex: "StartDate",
      key: "startDate",
      align: "left",
    },
    {
      title: t('analytics:mortality.endDate'),
      dataIndex: "EndDate",
      key: "endDate",
      align: "left",
    },
    {
      title: t('analytics:mortality.naturalMortality'),
      dataIndex: "NaturalMortality",
      key: "natural",
      align: "left",
    },
    {
      title: t('common:metrics.culling'),
      dataIndex: "Culling",
      key: "culling",
      align: "left",
    },
    {
      title: t('common:metrics.totalMortality'),
      dataIndex: "Mortality",
      key: "mortality",
      align: "left",
    },
  ];
  const onchangeHandler = async (e) => {
    try {
      const response = await axiosInstance.getListofBatches(
        e.target.value,
        "full"
      );
      setBatchData(response.list);
      setShowGraph(false);
    } catch (err) {
      setBatchData([]);
      console.log(err);
    }
  };
  const onSubmit = async (data, e) => {
    e.preventDefault();
    setShowloader(true);
    try {
      setBatchID(data.batchID);
      const response = await axiosInstance.getBatchwiseMortality(
        "batchwise",
        data.batchID
      );
      if (response?.data[0]) {
        setMortalityData(response?.data[0]);
        setShowGraph(true);
      }
      setShowloader(false);
    } catch (err) {
      console.log(err);
      setShowloader(false);
      setShowGraph(true);
    }
  };
  const [phaseData, setPhaseData] = useState([]);
  const fetchPhaseWiseMortality = async () => {
    try {
      const response = await axiosInstance.getBatchwiseMortality(
        "phasewise",
        batchID
      );
      console.log(response);
      if (response?.data[0]) {
        setPhaseData(response?.data[0]);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const onBatchChange = (e) => {
    setBatchID(e.target.value);
    setShowGraph(false);
  };
  const onFilterChange = (e) => {
    setShowGraph(false);
  };

  const getFarms = async (_userName) => {
    //alert(_userName)
    try {
      let userName = getUserName();
      if (role === Role.Admin) {
        userName = _userName;
      }
      const response = await axiosInstance.getListofFarms(userName);
      console.log(response);
      setFarmData(response.list);
    } catch (err) {
      console.log(err.message);
    }
  };
  const [farmers, setFarmers] = useState([]);
  const [selectedFarmer, setSelectedFarmer] = useState("");
  const getFarms_admin = async (farmerID) => {
    try {
      const response = await axiosInstance.getListofFarms_active_admin(
        farmerID
      );
      setFarmData(response.list);
    } catch (err) {
      console.log(err.message);
    }
  };
  const getFarmers = async () => {
    try {
      const response = await axiosInstance.getListofFarmers_admin();
      setFarmers(response.list);
    } catch (err) {
      console.log(err.message);
    }
  };
  useEffect(() => {
    if (role === Role.Admin) {
      getFarmers();
    } else {
      getFarms();
    }
  }, []);

  useEffect(() => {
    const farmerSelect = $("#selectFarmer").select2();
    farmerSelect.on("change", function (e) {
      const selectedFarmerID = e.target.value;
      setSelectedFarmer(selectedFarmerID);
      setBatchData([]);
      //   setShowDataTable(false)
      if (role === Role.Admin) {
        getFarms(selectedFarmerID);
        setShowGraph(false);
      }
    });

    const farmSelect = $("#selectFarm").select2();
    farmSelect.on("change", function (e) {
      trigger("famrmID"); // Manually trigger validation for 'selectFarm'
      setValue("famrmID", e.target.value, { shouldValidate: true });
      onchangeHandler(e);
    });

    return () => {
      farmerSelect.off("change");
      farmerSelect.select2("destroy");
      farmSelect.off("change");
      farmSelect.select2("destroy");
    };
  }, [farmData]);
  return (
    <div className="batchOperations">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h2 class="m-0 text-dark">{t('common:metrics.mortality')}</h2>
        </div>
      </div>
      <div className="card">
        <div class="card-body">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              {role == Role.Admin ? (
                <div className="col-md-3">
                  <div className="form-group">
                    <label>{t('common:select.farmer')}</label>
                    <select
                      style={{ width: "100%" }}
                      id="selectFarmer"
                      className="form-control form-control-sm"
                    >
                      <option value="">{t('common:select.dashed')}</option>
                      {farmers.map((item) => (
                        <option key={item.id} value={item.userName}>
                          {item.farmerName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              ) : (
                <></>
              )}
              <div className="col-md-3">
                <div className="form-group">
                  <label>{t('common:select.barn')}</label>
                  <select
                    class="form-control"
                    name="famrmID"
                    id="selectFarm"
                    {...register("famrmID", { required: true })}
                  >
                    <option value="">{t('common:select.dashed')}</option>
                    {farmData.map((item) => (
                      <option key={item.farmID} value={item.farmID}>
                        {item.farmName}
                      </option>
                    ))}
                  </select>
                  {errors.famrmID && (
                    <span className="err-msg">{t('common:validation.selectFarm')}</span>
                  )}
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label>{t('common:select.batch')}</label>
                  <select
                    class="form-control"
                    name="batchID"
                    onChange={onBatchChange}
                    {...register("batchID", { required: true })}
                  >
                    <option value="">{t('common:select.dashed')}</option>
                    {batchData.map((item) => (
                      <option key={item.batchID} value={item.batchID}>
                        {item.batchName}
                      </option>
                    ))}
                  </select>
                  {errors.batchID && (
                    <span className="err-msg">{t('common:validation.selectBatch')}</span>
                  )}
                </div>
              </div>
              {/* <div className="col-md-2">
                <div className="form-group">
                  <label>{t('common:select.filter')}</label>
                  <select
                    onChange={onFilterChange}
                    class="form-control"
                    name="filter"
                    {...register("filter", { required: true })}
                    // ref={register ({
                    //     required: t('forms:select.filter')

                    // })}
                  >
                    <option>{t('common:actions.select')}</option>
                    <option value="week">{t('common:time.week')}</option>
                    <option value="phase">{t('common:time.phase')}</option>
                    <option value="full">{t('common:time.full')}</option>
                  </select>
                  {errors.filter && (
                    <span className="err-msg">{t('common:validation.selectFilter')}</span>
                  )}
                </div>
              </div> */}

              <div className="col-md-1 form-group">
                <div class="spacer"></div>
                <input type="submit" value="Fetch" class="btn btn-primary" />
              </div>
              <div className="col-md-1">
                {showLoader ? (
                  <section {...containerProps} style={{ "margin-top": "30px" }}>
                    {indicatorEl} {/* renders only while loading */}
                  </section>
                ) : (
                  ""
                )}
              </div>
            </div>
          </form>
          {showGraph ? (
            <>
              <Tabs
                activeHeaderStyle={{ background: "transparent" }}
                onSelect={(index, label) => {
                  if (label === TAB_PHASE_WISE) {
                    fetchPhaseWiseMortality();
                  }
                }}
              >
                <Tab label={TAB_DAY_WISE} eventKey="day">
                  <div className="row mb-2 mt-2">
                    <div className="col-md-12">
                      <Table
                        columns={columns}
                        dataSource={mortalityData}
                        bordered
                        striped
                        size="small"
                        rowKey="day"
                        pagination={{
                          pageSizeOptions: ["5", "10", "20", "50"],
                          defaultPageSize: 10,
                          showSizeChanger: true,
                          showTotal: (total, range) =>
                            t('common:state.paginationTotal', { from: range[0], to: range[1], total }),
                        }}
                      />
                    </div>
                  </div>
                </Tab>
                <Tab label={TAB_PHASE_WISE}>
                  <Table
                    columns={phasecolumns}
                    dataSource={phaseData}
                    bordered
                    pagination={false}
                    size="small"
                    rowKey={(record) => `${record.Phase}-${record.Block}`}
                  />
                </Tab>
                <Tab label={t('analytics:mortality.naturalVsCulling')}>
                    <NaturalVsCullingChart chartData={mortalityData}></NaturalVsCullingChart>
                </Tab>
              </Tabs>
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};

export default BatchMortlaity;
